<div [class.tw-flex]="true" [class.md:tw-flex-row]="true" [class.tw-flex-col]="true"
  [class.mobile-view]="forceMobileView">

  <div class="main-card tw-flex tw-flex-col md:tw-w-1/2 tw-w-full" [class.box-shadow]="!isCreatingGroup">
    <div class="d-flex flex-row justify-content-between">
      <!-- Custom tab heading -->
      <div *ngIf="!isHomePage && !tab && !customTab" class="title">{{'CustomTabsPage.CustomTab' | translate}}</div>
      <div *ngIf="!isHomePage && tab" class="title">{{'Common.TAB' | translate}}</div>
      <div *ngIf="!isHomePage && customTab" class="title" translate="CustomTabsPage.CustomTab"></div>
      <div *ngIf="isHomePage" class="title">{{'Home' | translate}}</div>
      <!-- For create button -->
      <button *ngIf="action==='create'; else updateBtn"
        [ngClass]="{'create-btn-cg': forceMobileView, 'create-btn-tc': !forceMobileView}" (click)="onCreateClick()"
        mat-flat-button color="primary" 
        [disabled]="translationsMissing() || 
        (form.value.subtype != subtype.NAVIGATION_TAB && (form.invalid || selectedBIType == bannerImageType.Select_Image
         && this.bannerImage == '')) || disabledBtn ||
        (form.value.subtype == subtype.NAV_GROUP && !tabLayout) ||
        (form.value.subtype == subtype.NAVIGATION_TAB && !selectedTabForFooter) ||
        (form.value.subtype == subtype.TOPIC && !selectedItemIds) || (form.value.subtype == subtype.LIBRARY && !selectedItemIds) ||
        (form.value.subtype == subtype.FEEDS && !feedStream && selectedStreamDesign == streamDesignType.Feed) ||
        ((form.value.subtype == subtype.REQUEST || form.value.subtype == subtype.TILDA) && !selectedItemIds && !feedStream) ||
        (form.value.subtype == subtype.RequestCatalog  && allowRequestSelection && !selectedItemIds && !feedStream)">
        <span *ngIf="!isHomePage" translate="ExdrCommon.Create"></span>
        <span *ngIf="isHomePage" translate="ExdrCommon.Update"></span>
      </button>


      <!-- For update button -->
      <ng-template #updateBtn>
        <button [ngClass]="{'create-btn-cg': forceMobileView, 'create-btn-tc': !forceMobileView}"
          [disabled]="translationsMissing() || (form.controls.subtype?.value != subtype.NAVIGATION_TAB && (form.invalid || selectedBIType == bannerImageType.Select_Image
        && this.bannerImage == '')) || disabledBtn ||
           (form.controls.subtype?.value == subtype.NAVIGATION_TAB && !viewOnChanges && !selectedTabForFooter ) ||
           (form.value.subtype == subtype.TOPIC && !selectedItemIds) || (form.value.subtype == subtype.LIBRARY && !selectedItemIds) ||
           (form.value.subtype == subtype.FEEDS && !feedStream) ||
           (form.value.subtype == subtype.RequestCatalog && allowRequestSelection && !selectedItemIds && !feedStream) ||
           ((form.value.subtype == subtype.REQUEST || form.value.subtype == subtype.TILDA) && !selectedItemIds && !feedStream)" (click)="onUpdateClick()" mat-flat-button color="primary">
          <span translate="ExdrCommon.Update"></span>
        </button>
      </ng-template>

    </div>
    <div class="d-flex flex-row flex-grow-1">
      <form [formGroup]="form" class="d-flex flex-row flex-wrap flex-grow-1 flex-md-grow-0"
        [class.read-only]="tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key ==  tabKeyEnum.EspAttendance">
        <!-- Dropdown options for selecting type -->
        <mat-form-field appearance="outline" class="flex-grow-1" *ngIf="action==='create'||customTab">
          <mat-label translate="ExdrCommon.Type"></mat-label>
          <mat-select formControlName="subtype" (selectionChange)="onSubtypeSelected($event)">
            <mat-option [value]="subtype.NAVIGATION_TAB" *ngIf="utilityType == 'footer'">
              <span translate="CustomTabsPage.NavigationDropdown"></span>
            </mat-option>
            <mat-option [value]="-1" *ngIf="isHomePage && action==='update'">
              <span>{{"None" |translate}}</span>
            </mat-option>
            <mat-option [value]="subtype.FEEDS" *ngIf="!isHomePage">
              <span>{{'CustomTabsPage.FEEDS' |translate}}</span>
            </mat-option>
            <mat-option [value]="subtype.TOPIC"
              *ngIf="subtypeAddons.isTechnadoptAddon || customTab?.PublicProperties?.subtype == subtype.TOPIC">
              <span translate="CustomTabsPage.Topic"></span>
            </mat-option>
            <!-- NewCusTab 1: Add an option for Library -->
            <mat-option [value]="subtype.LIBRARY"
              *ngIf="subtypeAddons.isTechnadoptAddon || customTab?.PublicProperties?.subtype == subtype.LIBRARY">
              <span translate="CustomTabsPage.Library"></span>
            </mat-option>
            <mat-option [value]="subtype.REQUEST" *ngIf="subtypeAddons.isEspAddon  && !isHomePage">
              <span translate="CustomTabsPage.Request"></span>
            </mat-option>
            <mat-option [value]="subtype.REQUESTS" *ngIf="subtypeAddons.isEspAddon  && !isHomePage">
              <span translate="CustomTabsPage.Requests"></span>
            </mat-option>
            <mat-option [value]="subtype.RequestCatalog" *ngIf="subtypeAddons.isEspAddon  && !isHomePage">
              <span translate="CustomTabsPage.RequestCatalogue"></span>
            </mat-option>
            <mat-option [value]="subtype.ACTIVITIES" *ngIf="simplestrataAddon && !isHomePage">
              <span translate="CustomTabsPage.Activities"></span>
            </mat-option>
            <mat-option [value]="subtype.SCORE_CARD" *ngIf="simplestrataAddon && !isHomePage">
              <span translate="CustomTabsPage.ScoreCard"></span>
            </mat-option>
            <mat-option [value]="subtype.IFRAME">
              <span translate="CustomTabsPage.Iframe"></span>
            </mat-option>
            <mat-option [value]="subtype.WEB_LINK" *ngIf="!isHomePage && !(tabtypehome === 'home')">
              <span translate="CustomTabsPage.WebLink"></span>
            </mat-option>
            <mat-option [value]="subtype.DASHBOARD" *ngIf="subtypeAddons.isDashboardsAddon && !isHomePage">
              <span translate="CustomTabsPage.Dashboard"></span>
            </mat-option>
            <mat-option [value]="subtype.NAV_GROUP"
              *ngIf="!isHomePage && !(tabtypehome === 'home') && utilityType !== TabUtilityType.FloatingTab">
              <span>{{'Common.TAB-Group' |translate}}</span>
            </mat-option>
            <mat-option [value]="subtype.TILDA" *ngIf="subtypeAddons.isTildaAddon">
              <span translate="CustomTabsPage.DesignPages"></span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="selectedSubtype == subtype.NAV_GROUP">

          <!-- Adding layout dropdown for tabGroup -->
          <mat-form-field appearance="outline" class="flex-grow-1" *ngIf="action==='create'||customTab" required>
            <mat-label translate="CustomTabsPage.Layout"></mat-label>
            <mat-select (selectionChange)="onTabLayoutSelected($event)" required [(ngModel)]="tabLayout"
              [ngModelOptions]="{ standalone: true }">
              <mat-option value="navigation">
                <span>{{'CustomTabsPage.NavigationTab' |translate}}</span>
              </mat-option>
              <mat-option value="innertab">
                <span translate="CustomTabsPage.InnerTab"></span>
              </mat-option>
            </mat-select>
          </mat-form-field>

        </ng-container>

        <mat-form-field appearance="outline" class="flex-grow-1"
          *ngIf="selectedSubtype == subtype.NAVIGATION_TAB && allTabs?.length">
          <mat-label translate="ExdrCommon.NavigationTab"></mat-label>
          <mat-select formControlName="footerTabCtrl" (selectionChange)="onFooterTabSelected($event)">

            <ng-container *ngFor="let tab of allTabs">
              <mat-option [value]="tab?.key" *ngIf="tabAvailabilityForFooter(tab)">
                <span>{{tab?.name}}</span>
              </mat-option>
            </ng-container>

          </mat-select>
        </mat-form-field>

        <!-- Title of the tab -->
        <ng-container *ngIf="!isHomePage && selectedSubtype != subtype.NAVIGATION_TAB">
          <mat-form-field appearance="outline" class="flex-grow-1"
            [class.read-only]="tab?.key == tabKeyEnum.SocialMedia || tab?.key == tabKeyEnum.CustomersService ">
            <mat-label *ngIf="selectedSubtype != subtype.NAV_GROUP" translate="CustomTabsPage.TabTitle"></mat-label>
            <mat-label *ngIf="selectedSubtype == subtype.NAV_GROUP" translate="CustomTabsPage.TabName"></mat-label>
            <input type="text" matInput formControlName="title" (focusout)="onTitleFocusOut($event)" />
            <mat-error *ngIf="form.get('title').errors?.maxlength&&form.get('title').touched"
              [innerHTML]="'GroupSettingPage.MaxLength' | translate : {maxLength:form.get('title').errors?.maxlength?.requiredLength, actualLength: form.get('title').errors?.maxlength?.actualLength}">
            </mat-error>
            <mat-error *ngIf="form.get('title').hasError('required')" translate="Product.Required">
            </mat-error>
          </mat-form-field>
        </ng-container>

        <!-- URL name -->
        <mat-form-field appearance="outline" class="flex-grow-1" *ngIf="form.get('urlName')">
          <mat-label translate="CustomTabsPage.UrlName"></mat-label>
          <input type="text" matInput formControlName="urlName" required maxlength="100"
            [disabled]="action=='update' && customTab?.PublicProperties?.urlName" (focusout)="setUpUrlName($event)" />
          <mat-hint class="tw-mb-1" align="start">Use only lowercase letters, digits, underscores, and
            hyphens.</mat-hint>
          <mat-error class="tw-mb-1" *ngIf="form.get('urlName').hasError('required')" translate="Product.Required">
          </mat-error>
          <mat-error class="tw-mb-1" *ngIf="form.get('urlName').hasError('pattern')"
            translate="CustomTabsPage.UrlNamePattern">
          </mat-error>
          <mat-error class="tw-mb-1" *ngIf="form.get('urlName').hasError('notUnique')"
            translate="CustomTabsPage.UrlNameExists">
          </mat-error>
        </mat-form-field>

        <!-- Custom options based on type selected -->
        <ng-container *ngIf="((selectedSubtype == subtype.RequestCatalog ||
        selectedSubtype == subtype.TOPIC || selectedSubtype == subtype.LIBRARY || selectedSubtype == subtype.DASHBOARD ||
        selectedSubtype == subtype.REQUEST || tab?.key ==  tabKeyEnum.SocialMedia || selectedSubtype == subtype.REQUESTS
        ) && customTab?.PublicProperties?.isDefaultTab != 1) || 
        (tab?.key == tabKeyEnum.EspRecords || tab?.key == tabKeyEnum.EspSurveys || tab?.key == tabKeyEnum.Requests)">

          <div class="icon-title" [translate]="placeholder"></div>
          <div style="width: 100%;"
            *ngIf="(selectedSubtype == subtype.RequestCatalog) ||
          (tab?.key == tabKeyEnum.EspRecords || tab?.key == tabKeyEnum.EspSurveys || tab?.key == tabKeyEnum.Requests || selectedSubtype == subtype.REQUESTS)"
            [ngStyle]="{'margin-bottom': !allowRequestSelection?'0rem':'1rem'}">
            <mat-slide-toggle [checked]="!allowRequestSelection" (change)="toggleRequestSelection($event)">
              <span class="toggle-title" translate="CustomTabsPage.AllRequests"></span>
            </mat-slide-toggle>
          </div>
          <ng-container *ngIf="selectedSubtype == subtype.TOPIC ||
          selectedSubtype == subtype.REQUEST || selectedSubtype == subtype.DASHBOARD ||
           ((selectedSubtype == subtype.RequestCatalog) || (tab?.key == tabKeyEnum.EspRecords || tab?.key == tabKeyEnum.EspSurveys || tab?.key == tabKeyEnum.Requests || selectedSubtype == subtype.REQUESTS) &&
            allowRequestSelection) || tab?.key==tabKeyEnum.SocialMedia">
            <mat-form-field appearance="outline" class="flex-grow-1 custom-tab-value"
              (click)="openSelectValueDialog($event)">
              <input type="text" matInput readonly
                [value]="selectedItemNames == '' ? (placeholder | translate) : selectedItemNames" />
              <mat-icon matSuffix>chevron_right</mat-icon>
            </mat-form-field>
          </ng-container>


          <!-- NewCusTab 3: Add a container to appear for selecting topics for Library -->
          <ng-container *ngIf="selectedSubtype == subtype.LIBRARY">
            <mat-form-field appearance="outline" class="flex-grow-1 custom-tab-value"
              (click)="openSelectValueDialog($event)">
              <input type="text" matInput readonly
                [value]="selectedItemNames == '' ? (placeholder | translate) : selectedItemNames" />
              <mat-icon matSuffix>chevron_right</mat-icon>
            </mat-form-field>
          </ng-container>
        </ng-container>

        <!-- Adding a description field for subtype.Nav_Group -->
        <ng-container *ngIf="selectedSubtype == subtype.NAV_GROUP">
          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label translate="CustomTabsPage.Description"></mat-label>
            <textarea class="text-area" matInput placeholder="Description" matTextareaAutosize matAutosizeMinRows="3"
              matAutosizeMaxRows="5" [maxlength]="metaDescriptionMaxLength" [(ngModel)]="tabDescription"
              [ngModelOptions]="{ standalone: true }"></textarea>
          </mat-form-field>
        </ng-container>

        <mat-form-field appearance="outline" class="flex-grow-1" *ngIf="form.get('url')">
          <mat-label translate="URL"></mat-label>
          <input type="text" matInput formControlName="url" required />
          <mat-error *ngIf="form.get('url').hasError('required')" translate="Product.Required">
          </mat-error>
          <mat-error *ngIf="form.get('url').hasError('url')" translate="Product.EnterValidUrl">
          </mat-error>
        </mat-form-field>
      </form>
    </div>

    <ng-container *ngIf="!isHomePage && utilityType != TabUtilityType.FooterUtilities">
      <div class="icon-title" translate="CustomTabsPage.IconForTab"
        [class.read-only]="tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key == tabKeyEnum.SocialMedia || tab?.key ==  tabKeyEnum.EspAttendance || tab?.key == tabKeyEnum.CustomersService">
      </div>
      <div class="custom-tab-icons"
        [class.read-only]="tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key == tabKeyEnum.SocialMedia || tab?.key ==  tabKeyEnum.EspAttendance || tab?.key == tabKeyEnum.CustomersService">
        <div *ngFor="let icon of icons" class="custom-tab-icon" [ngClass]="{'active': selectedTabIcon == icon.id}"
          (click)="changeIcon(icon.id)">
          <div class="overlay"></div>
          <span [inlineSVG]="icon.path" [ngClass]="{'fill-svg-themed': selectedTabIcon == icon.id}"></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="form.value.subtype != '-1'">
      <mat-form-field [class.read-only]="utilityType === 'icon'"
        *ngIf="tab?.key == tabKeyEnum.Profile && tab?.utilityType != TabUtilityType.FooterUtilities && utilityType !== TabUtilityType.FloatingTab"
        class="no-padding web-menu" appearance="outline">
        <mat-label translate="GroupInfoPage.ShowOnWebMenu"></mat-label>
        <mat-select [value]="tab.webMenu" (selectionChange)="changeWebMenu($event)">
          <mat-option [value]="webMenuEnum.SIGN_IN">
            <span translate="LoginForm.SignIn"></span>
          </mat-option>
          <mat-option [value]="webMenuEnum.SIGN_UP">
            <span translate="LoginForm.SignUp"></span>
          </mat-option>
          <mat-option [value]="webMenuEnum.SIGN_IN_UP">
            <span translate="GroupInfoPage.SignInUp"></span>
          </mat-option>
          <mat-option [value]="webMenuEnum.PROFILE">
            <span translate="PROFILE"></span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- stream  -->
      <ng-container *ngIf="selectedSubtype == subtype.FEEDS">
        <xcdrs-custom-feed-stream class="custom-tab-value feed-steam" [autoCompleteData]="PublicProperties"
          (newItemInserted)="newStreamAdded()" [selectedValues]="selectedValues" [title]="'Stream'"
          (selectedTags)="onStreamSelected($event)" valueKeyName="feedStream" idKeyName="customTabId">
        </xcdrs-custom-feed-stream>

        <mat-form-field appearance="outline" class="custom-tab-value">
          <mat-label translate="CustomTabsPage.CustomFeed.Type"></mat-label>
          <mat-select [value]="selectedStreamDesign" [disabled]="action === 'update' || disableStreamDesignSelection"
            (selectionChange)="onStreamDesignSelected($event)">

            <mat-option [value]="streamDesignType.Media">
              <span translate="CreatePost.Media"></span>
            </mat-option>

            <mat-option [value]="streamDesignType.Feed">
              <span translate="Feed"></span>
            </mat-option>

            <mat-option [value]="streamDesignType.Blog">
              <span translate="CustomTabsPage.Blog"></span>
            </mat-option>

            <mat-option [value]="streamDesignType.Links">
              <span translate="CustomTabsPage.Links"></span>
            </mat-option>

          </mat-select>
        </mat-form-field>

      </ng-container>

      <ng-container>
        <div class="icon-title" translate="CustomTabsPage.ShowIn"
          [class.read-only]="tab?.key == tabKeyEnum.Profile && tab?.utilityType != TabUtilityType.FooterUtilities  ">
        </div>
        <div class="custom-tab-icons d-flex"
          [class.read-only]="(tab?.key == tabKeyEnum.Profile && tab?.utilityType != TabUtilityType.FooterUtilities)">
          <div *ngFor="let icon of viewOnData;index as idx" class="custom-tab-icon"
            [ngClass]="{'active': viewOnData[idx].active}" (click)="changeView(idx)">
            <div class="overlay"></div>
            <span [inlineSVG]="icon.path" [ngClass]="{'fill-svg-themed': viewOnData[idx].active}"></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedSubtype === subtype.FEEDS || tab?.key === tabKeyEnum.Feed || tab?.key === tabKeyEnum.Blog">
        <xcdrs-allow-options (optionsChanged)="onAllowOptionsChanged($event)"
          [allowFeedOptions]="allowFeedOptions"></xcdrs-allow-options>
      </ng-container>

      <ng-container *ngIf="tab?.key == tabKeyEnum.EspAttendance">
        <div class="icon-title read-only" translate="CustomTabsPage.SelectRequest"></div>
        <mat-form-field appearance="outline" class="custom-tab-value read-only">
          <input type="text" matInput disabled [value]="'Attendance'" />
          <mat-icon matSuffix>chevron_right</mat-icon>
        </mat-form-field>
      </ng-container>

      <!-- Esp Divider -->
      <ng-container
        *ngIf="(tab?.key == tabKeyEnum.EspSurveys || tab?.key == tabKeyEnum.Requests || selectedSubtype == subtype.REQUESTS)">
        <div class="icon-title" translate="CustomTabsPage.Dividers.SubTabs"></div>
        <mat-form-field appearance="outline" class="custom-tab-value">
          <mat-label translate="CustomTabsPage.Dividers.SelectSubTabs"></mat-label>
          <mat-select [formControl]="espDividers" multiple>
            <mat-option *ngFor="let divider of espDividerEnumValues" [value]="divider">
              {{('CustomTabsPage.Dividers.'+ divider) |translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="(selectedSubtype == subtype.ACTIVITIES || tab?.key == tabKeyEnum.Activities)">
        <div class="icon-title" translate="CustomTabsPage.Dividers.SubTabs"></div>
        <mat-form-field appearance="outline" class="custom-tab-value">
          <mat-label translate="CustomTabsPage.Dividers.SelectSubTabs"></mat-label>
          <mat-select [formControl]="activitiesDivders" multiple>
            <mat-option *ngFor="let divider of activitiesDividerEnumValues" [value]="divider">
              {{('CustomTabsPage.Dividers.'+ divider) |translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="(selectedSubtype == subtype.SCORE_CARD || tab?.key == tabKeyEnum.ScoreCard)">
        <div class="icon-title" translate="CustomTabsPage.Dividers.SubTabs"></div>
        <mat-form-field appearance="outline" class="custom-tab-value">
          <mat-label translate="CustomTabsPage.Dividers.SelectSubTabs"></mat-label>
          <mat-select [formControl]="scorecardDivders" multiple>
            <mat-option *ngFor="let divider of scoreCardDividerEnumValues" [value]="divider">
              {{('CustomTabsPage.Dividers.'+ divider) |translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <!-- Design DropDown -->
      <ng-container *ngIf="selectedStreamDesign === streamDesignType.Links">
        <mat-form-field appearance="outline" class="custom-tab-value">
          <mat-label translate="CustomTabsPage.CustomFeed.Design"></mat-label>
          <mat-select [value]="selectedDesign" (selectionChange)="onDesignSelected($event)">
            <mat-option [value]="designType.Cards">
              <span translate="CreatePost.Cards"></span>
            </mat-option>
            <mat-option [value]="designType.List">
              <span translate="CreatePost.List"></span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>


      <!-- tilda -->

      <ng-container *ngIf="selectedSubtype == subtype.TILDA">

        <div class="icon-title" [translate]="placeholder"></div>
        <mat-form-field appearance="outline" class="custom-tab-value" (click)="openSelectValueDialog($event)">
          <input type="text" matInput readonly
            [value]="selectedDesignPage == '' ? (placeholder | translate) : selectedDesignPage" />
          <mat-icon matSuffix>chevron_right</mat-icon>
        </mat-form-field>

      </ng-container>

      <!--  -->

      <ng-container *ngIf="form.controls.subtype?.value != '7'">
        <!-- <div class="icon-title" *ngIf="groupsVisibility?.length"
          [class.read-only]="tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key ==  tabKeyEnum.EspAttendance">
          {{'Common.VisibleBy'
          |translate}}</div>
        <xcdrs-tab-visibilty [tab]="tab" [customTab]="customTab" [espAddon]="espAddon" [technadoptAddon]="technadoptAddon"
          [isHomePage]="isHomePage" [form]="form" (groupVisibilitiesEmitter)="onGroupVisibilitiesEmitter($event)">
        </xcdrs-tab-visibilty> -->

        <!-- <div class="icon-title" *ngIf="hiddenFromGroups?.length"
          [class.read-only]="tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key ==  tabKeyEnum.EspAttendance">
          {{'Common.HiddenFrom'
          |translate}}</div> -->
        <xcdrs-tab-visibilty #visibleByComponent [tab]="tab" [customTab]="customTab" [espAddon]="espAddon"
          [initialSubtypeTitle]="sendTitle()" [technadoptAddon]="technadoptAddon" [tabOrderAddon]="tabOrderAddon"
          [isHomePage]="isHomePage" [form]="form">
        </xcdrs-tab-visibilty>
      </ng-container>


    </ng-container>

    <ng-container *ngIf="tab?.key !=  tabKeyEnum.EspAttendance && tab?.utilityType != TabUtilityType.FooterUtilities">
      <div class="d-flex flex-row flex-grow-1" *ngIf="enableMetaData && form.controls.subtype?.value != '7'">
        <form [formGroup]="form" class="d-flex flex-column flex-grow-1 flex-md-grow-0">
          <div class="icon-title">{{'Metadata' | translate}}</div>
          <mat-form-field appearance="outline">
            <mat-label translate="PageTitle"></mat-label>
            <input type="text" matInput maxlength="100" formControlName="metaTitle" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label translate="MetaDescription"></mat-label>
            <textarea class="text-area" matInput formControlName="metaDescription" placeholder="Description"
              matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="5"
              [maxlength]="metaDescriptionMaxLength"></textarea>

          </mat-form-field>
        </form>
      </div>
      <div class="d-flex flex-row flex-grow-1" *ngIf="(selectedSubtype != subtype.IFRAME && selectedSubtype != subtype.WEB_LINK &&
        selectedSubtype != subtype.REQUEST && selectedSubtype != subtype.RequestCatalog &&
        selectedSubtype != subtype.NAV_GROUP && selectedSubtype != subtype.TILDA &&
        form.controls.subtype?.value != '7' && tab?.utilityType != TabUtilityType.FooterUtilities)">
        <form [formGroup]="form" class="d-flex flex-column flex-grow-1 flex-md-grow-0">

          <div class="banner-toggle-container">
            <mat-slide-toggle [formControl]="bannerCtrl">
              <div style="font-weight: 700;">{{'CustomTabsPage.Banner' | translate}}
              </div>
            </mat-slide-toggle>
          </div>

          <mat-form-field appearance="outline">
            <mat-label translate="CustomTabsPage.Banner-Heading"></mat-label>
            <textarea class="text-area" matInput formControlName="bannerHeading" placeholder="Heading"
              matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="5" maxlength="75"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label translate="CustomTabsPage.Banner-SubHeading"></mat-label>
            <textarea class="text-area" matInput formControlName="bannerSubHeading" placeholder="Subheading"
              matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="5" maxlength="125"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="flex-grow-1">
            <mat-label translate="CustomTabsPage.Banner-Background"></mat-label>
            <mat-select [value]="selectedBIType" (selectionChange)="onBITypeSelected($event)">

              <mat-option [value]="bannerImageType.None">
                <span translate="CustomTabsPage.BannerImageNone"></span>
              </mat-option>

              <mat-option [value]="bannerImageType.White">
                <span translate="CustomTabsPage.BannerImageWhite"></span>
              </mat-option>

              <mat-option [value]="bannerImageType.Select_Image">
                <span translate="CustomTabsPage.BannerImageSelect"></span>
              </mat-option>

            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="selectedBIType == bannerImageType.Select_Image">
            <file-upload-area style="height: 6.25rem; margin-bottom: 1.25rem;" [hideInfoText]="true"
              class="d-flex upload-area flex-column flex-grow-0" [type]="0" [url]="bannerImage" [cropMode]="true"
              (fileSelected)="onImageSelected($event)" (fileRemoved)="onImageRemoved()">
            </file-upload-area>
          </ng-container>

          <!-- <div class="btn-label-container"> -->
          <mat-form-field appearance="outline">
            <mat-label translate="CustomTabsPage.Banner-ButtonLabel"></mat-label>
            <input matInput formControlName="bannerButtonLabel">
            <mat-error *ngIf="form.get('bannerButtonLabel').hasError('required')" translate="Product.Required">
            </mat-error>
          </mat-form-field>
          <!-- </div> -->

          <mat-form-field appearance="outline">
            <mat-label translate="CustomTabsPage.Banner-ButtonLink"></mat-label>
            <input matInput formControlName="bannerButtonLink">
            <mat-icon matSuffix svgIcon="xcdrs-link"></mat-icon>
            <mat-error *ngIf="form.get('bannerButtonLink').hasError('required')" translate="Product.Required">
            </mat-error>
            <mat-error *ngIf="form.get('bannerButtonLink').hasError('url')" translate="Product.EnterValidUrl">
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="tab-form-date">
            <mat-label translate="SmartContact.StartDate"></mat-label>
            <div class="tw-flex tw-flex-row">
              <input class="t-mt-10" matInput formControlName="startDate" [matDatepicker]="startPicker" [min]="minDate"
                (ngModelChange)="onChangeStartDate($event)">
              <div class="tw-flex tw-items-center t-mt-10">
                <mat-icon class="tw-cursor-pointer" *ngIf="form.get('startDate').value" matSuffix
                  (click)="clearDate('startDate')">close</mat-icon>
                <mat-datepicker-toggle class="tab-form-datepicker-toggle" matIconSuffix [for]="startPicker">
                </mat-datepicker-toggle>
              </div>
            </div>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="tab-form-date">
            <mat-label translate="SmartContact.EndDate"></mat-label>
            <div class="tw-flex tw-flex-row">
              <input [min]="form.value.startDate" class="t-mt-10" matInput formControlName="endDate"
                [matDatepicker]="endPicker">
              <div class="tw-flex tw-items-center t-mt-10">
                <mat-icon class="tw-cursor-pointer" *ngIf="form.get('endDate').value" matSuffix
                  (click)="clearDate('endDate')">close</mat-icon>
                <mat-datepicker-toggle class="tab-form-datepicker-toggle" matIconSuffix
                  [for]="endPicker"></mat-datepicker-toggle>
              </div>
            </div>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>

        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="groupSettingsAddonData.length && form.controls.subtype?.value != '7'">
      <div class="tw-flex tw-flex-col" style="max-width: 25rem;" [class.read-only]="tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key ==  tabKeyEnum.SocialMedia
        || tab?.key ==  tabKeyEnum.EspAttendance || tab?.key == tabKeyEnum.CustomersService">
        <div class="icon-title" translate="AppAppearance.Languages"></div>
        <ng-container *ngFor="let groupLanguage of groupSettingsAddonData">
          <div fxLayout="column" class="tab-lang-container">
            <div fxLayout fxLayoutAlign="start center" fxLayoutGap="0.5rem" class="toggle-container">
              <mat-slide-toggle [checked]="groupLanguage.isEnable==='1'"
                [disabled]="canDisableTab(groupLanguage.langKey)"
                (toggleChange)="groupLanguage.isEnable= (groupLanguage.isEnable=='1') ? '0': '1';" class="toggle-btn">
              </mat-slide-toggle>
              <div class="lang-title">
                {{'Stemexe-Language.'+groupLanguage.langKey |translate}}
              </div>
            </div>
            <div fxLayout fxLayoutAlign="center center" fxLayoutGap="0.75rem">
              <form [formGroup]="form" class="d-flex flex-grow-1 flex-md-grow-0">
                <mat-form-field appearance="outline" class="flex-grow-1">
                  <mat-label>{{"CustomTabsPage.TabName" |translate}}</mat-label>
                  <input type="text" matInput [readonly]="groupLanguage.langKey == 'en'"
                    [value]="groupLanguage.langKey == 'en' ? form.get('title')?.value : groupLanguage.name"
                    [required]="groupLanguage.isEnable==='1'" (keyup)="groupLanguage.name=$event?.target?.value" />
                </mat-form-field>
              </form>
            </div>
            <div fxLayout="column">
              <ng-container
                *ngIf="((form.get('subtype')?.value===subtype.IFRAME || form.get('subtype')?.value===subtype.TOPIC) && groupLanguage.langKey !== 'en')">
                <mat-form-field appearance="outline" class="flex-grow-1">
                  <mat-label translate="ExdrCommon.Type"></mat-label>
                  <mat-select [(ngModel)]="groupLanguage.urlType"
                    (ngModelChange)="onUrlTypeChanged($event, groupLanguage)">
                    <mat-option [value]="'baseUrl'">
                      {{(form.get('subtype')?.value === subtype.IFRAME ? 'CustomTabsPage.UseBaseUrl' : 'CustomTabsPage.UseBaseTopic') |translate}}</mat-option>
                    <mat-option [value]="'differentUrl'">{{(form.get('subtype')?.value===subtype.IFRAME ?
                      'CustomTabsPage.UseDifferentUrl' : 'CustomTabsPage.UseDifferentTopic') |translate}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <ng-container *ngIf="(groupLanguage.urlType==='differentUrl')">
                  <mat-form-field appearance="outline" class="flex-grow-1"
                    *ngIf="(form.get('subtype')?.value===subtype.IFRAME)">
                    <mat-label translate="URL"></mat-label>
                    <input type="text" matInput [(ngModel)]="groupLanguage.url" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" *ngIf="(form.get('subtype')?.value === subtype.TOPIC)"
                    class="flex-grow-1 custom-tab-value" (click)="setTopicForLang(groupLanguage.langKey)">
                    <input type="text" matInput readonly
                      [value]="!groupLanguage?.topic?.name ? ('CustomTabsPage.Topic' | translate) : groupLanguage?.topic?.name" />
                    <mat-icon matSuffix>chevron_right</mat-icon>
                  </mat-form-field>

                  <!-- <mat-form-field appearance="outline" *ngIf="(form.get('subtype')?.value === subtype.LIBRARY)"
                    class="flex-grow-1 custom-tab-value" (click)="setLibraryForLang(groupLanguage.langKey)">
                    <input type="text" matInput readonly
                      [value]="!groupLanguage?.library?.name ? ('CustomTabsPage.SelectTopicType' | translate) : groupLanguage?.library?.name" />
                    <mat-icon matSuffix>chevron_right</mat-icon>
                  </mat-form-field> -->
                </ng-container>
              </ng-container>

            </div>
          </div>
          <!-- (groupLanguage.isEnable==='1') && -->

        </ng-container>

      </div>
    </ng-container>


  </div>

  <!-- Left Side -->
  <div class="main-card d-flex flex-column  md:tw-w-1/2 tw-w-full m-view-top">
    <!-- For create button -->
    <ng-container *ngIf="!forceMobileView">

      <button *ngIf="action==='create' ;else updateBtnS" class="create-btn-right" (click)="onCreateClick()"
        mat-flat-button color="primary" [disabled]="translationsMissing() || (form.value.subtype != subtype.NAVIGATION_TAB && (form.invalid || selectedBIType == bannerImageType.Select_Image
          && this.bannerImage == '')) || disabledBtn ||
        (form.value.subtype == subtype.NAV_GROUP && !tabLayout) ||
        (form.value.subtype == subtype.NAVIGATION_TAB && !selectedTabForFooter) ||
        (form.value.subtype == subtype.TOPIC && !selectedItemIds) || (form.value.subtype == subtype.LIBRARY && !selectedItemIds) ||
        (form.value.subtype == subtype.FEEDS && !feedStream && selectedStreamDesign == streamDesignType.Feed) ||
        ((form.value.subtype == subtype.REQUEST || form.value.subtype == subtype.TILDA) && !selectedItemIds && !feedStream) ||
        (form.value.subtype == subtype.RequestCatalog  && allowRequestSelection && !selectedItemIds && !feedStream)">
        <span *ngIf="!isHomePage" translate="ExdrCommon.Create"></span>
        <span *ngIf="isHomePage" translate="ExdrCommon.Update"></span>
      </button>
      <ng-template #updateBtnS>
        <button class="create-btn-right"
          [disabled]="translationsMissing() || (form.controls.subtype?.value != subtype.NAVIGATION_TAB && (form.invalid || selectedBIType == bannerImageType.Select_Image
        && this.bannerImage == '')) || disabledBtn ||
            (form.controls.subtype?.value == subtype.NAVIGATION_TAB && !viewOnChanges && !selectedTabForFooter ) ||
            (form.value.subtype == subtype.TOPIC && !selectedItemIds) || (form.value.subtype == subtype.LIBRARY && !selectedItemIds) ||
            (form.value.subtype == subtype.FEEDS && !feedStream) ||
            (form.value.subtype == subtype.RequestCatalog && allowRequestSelection && !selectedItemIds && !feedStream) ||
            ((form.value.subtype == subtype.REQUEST || form.value.subtype == subtype.TILDA) && !selectedItemIds && !feedStream)"
          (click)="onUpdateClick()" mat-flat-button color="primary">
          <span translate="ExdrCommon.Update"></span>
        </button>
      </ng-template>

    </ng-container>

    <!-- Only show background color if neither footer nor utilities or any of the following subtypes -->
    <div class="d-flex flex-row"
      *ngIf="!(form.value.subtype == subtype.WEB_LINK || form.value.subtype == subtype.NAV_GROUP || form.value.subtype == subtype.IFRAME || tab?.key == tabKeyEnum.Chat || tab?.key ==  tabKeyEnum.Profile || tab?.key ==  tabKeyEnum.EspAttendance)">
      <div class="tw-flex tw-flex-col tw-w-full">
        <!-- Background color Are -->
        <div class="slide-bg-container tw-w-full">
          <div class="slide-bg-heading">{{'Product.Slide.BackgroundColor' |translate}}</div>
          <ul class="theme-colors-list">
            <li class="color-list-item" *ngFor="let sbg of slideBgColors" (click)="onColorClick(sbg.shade)"
              [ngClass]="{'checked':activeSlideBg == sbg.shade }">
              <span class="inner-item" [ngStyle]="{'background-color': sbg.shade}">
                <div class="circle" [ngStyle]="{'background-color': sbg.main}"></div>
              </span>
          </ul>
        </div>
        <!-- Hex color placement -->
        <div class="tw-mt-4 tw-flex tw-flex-row tw-gap-4">
          <div class="preview-custom-color" [class.disabled]="customColor.invalid"
            (click)="customColor.valid && onColorClick(customColor.value)">
            <div class="color-box" [style.background]="customColor ? customColor.value : 'transparent'">
              <mat-icon *ngIf="customColor.valid && isCustomColor && customColor.value ==activeSlideBg"
                style="color:white">check</mat-icon>
            </div>
          </div>
          <mat-form-field appearance="outline" style="width:13.75rem !important">
            <mat-label translate="AppAppearance.CustomColor"></mat-label>
            <input type="text" matInput [formControl]="customColor" (focus)="onFocus()" (blur)="onBlur()"
              (keydown)="validateInput($event)" maxlength="9" autocapitalize="characters"
              (input)="filterHash($event.target.value, $event)">
            <mat-error *ngIf="customColor.errors?.invalidHex">
              {{ customColor.errors.invalidHex }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div *ngIf="shouldShow()" class="d-flex flex-row tw-mt-3">
      <!-- Highlighted tab toggle -->
      <mat-slide-toggle [formControl]="highlightTab" (change)="onHightlightToggleChange($event)">
        <span class="toggle-title" translate="CustomTabsPage.HighlightTab"></span>
      </mat-slide-toggle>
    </div>

  </div>
</div>